import { render, staticRenderFns } from "./RemoteData.form.vue?vue&type=template&id=38f68e0d&scoped=true&"
import script from "./RemoteData.form.vue?vue&type=script&lang=js&"
export * from "./RemoteData.form.vue?vue&type=script&lang=js&"
import style0 from "./RemoteData.form.vue?vue&type=style&index=0&id=38f68e0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f68e0d",
  null
  
)

export default component.exports